export default {
  label: {
    notes: 'Label of show signals action for visualisation',
    message: 'Show all signals',
  },
};
